import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

 const Slide = ({item}) => {
  return (
    <div className='w-full rounded-lg overflow-hidden relative'>
      <img className='w-full' src={item.image} alt={item?.title} />
      <div className='absolute z-10 left-[10%] top-[10%] w-[45%] md:top-[20%]  md:w-1/3 xl:top-1/3  xl:w-1/3  h-full'>
        <div className='flex flex-col gap-4 items-start'>
          <h4 className='hidden md:block'>{item.title}</h4>
          <p className='text-base md:text-2xl xl:text-4xl font-bold'>{item.describe}</p>
          <Link to={item?.action.href} className="rounded-full font-semibold px-4 py-2 text-xs md:text-sm md:px-5 md:py-2 bg-[--color-button-1] hover:bg-[--color-button-3] hover:text-white transition-all duration-300">{item?.action?.title}</Link>
        </div>
        </div>
    </div>
  )
}
export default Slide;